import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { view05ImageOptions } from './views/view05'

class X46Wheel extends Component {
    constructor(props) {
        super(props);
        this.handleWheelChange = this.handleWheelChange.bind(this);
    }
    
    handleWheelChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Wheel = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = view05ImageOptions;

        let image = <ConfiguratorImage boat="X4_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Wheels' /></h1>
                    <p><Trans defaults='The electronic equipment shown on this render is optional. Please contact your local dealer for further information.' /></p>
                    <RadioGroup label="Options:" options={this.props.wheelOptions} value={this.props.configuration.Wheel} onChange={this.handleWheelChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X46Wheel);


// WEBPACK FOOTER //
// ./src/X46/X46Wheel.js